import type { PaletteOptions } from '@mui/material'

export const palette: PaletteOptions = {
  mode: 'dark',
}
